












































































import CommonBase from "../../CommonBase";
import rd from "../../../modules/vRoutedefs";
import {Component} from "vue-property-decorator";
import ReportCard from "@/components/users/reports/ReportCard.vue";

@Component({
    components: {
        "at-report-card": ReportCard,
    }
})
export default class ReportCards extends CommonBase {
  rPhonelist = rd.users.reports.phonelist.path;
  rAllusers = rd.users.reports.allusers.path;
  rRoles = rd.users.reports.roles.path;
  rExpirationLoc = rd.users.reports.cardexpirationlocation.path;
  rExpirationCompany = rd.users.reports.cardexpirationcompany.path;
  rWithoutCard = rd.users.reports.withoutCard.path;
  rInfectionTracer = rd.users.reports.infectiontrace.path;
  rWithoutPhone = {name: rd.users.reports.withoutPhone.name};
}
